import React from "react";
import PropTypes from "prop-types";

const Row = ({ title, pageURL, current, prefix }) => {
  return (
    <div className={current ? "current side-row" : "side-row"}>
      <a className="rowLink" href={pageURL}>
        {current && <div className="current-label">Now Reading:</div>}
        {prefix && <span className="prefix">{prefix}: </span>}
        {title && <span className="rowTitle">{title}</span>}
      </a>
    </div>
  );
};

Row.propTypes = {
  title: PropTypes.string,
  pageURL: PropTypes.string,
  current: PropTypes.bool,
  prefix: PropTypes.string
};

export default Row;
